<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('dept.c1.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c1.t1.title')"
        :textArray="uakGoalsTexts"
        :downloadText="$t('dept.c1.t1.download')"
        downloadFileName="Flyer_Hans-Lebrecht-Schule_Unterricht_am_Krankenbett.pdf"
      />
      <ContentImageTile
        embedded
        imageSource="/img/schulhaus/uniklinikum.jpg"
        :caption="$t('dept.c1.img.caption')"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c1.t2.title')"
        :textArray="[$t('dept.c1.t2.p0')]"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c1.t3.title')"
        :textArray="uakHomeLessonTexts"
        :linkText="$t('dept.c1.t3.link')"
        linkUrl="https://bc.schulamt-bw.de/,Lde/Startseite/Themen-ABC/Hausunterricht?LISTPAGE=cbi:///cms/9844640"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c1.t4.title')"
        :textArray="uakAvatarTexts"
        :linkText="$t('dept.c1.t4.link')"
        linkUrl="https://www.lmz-bw.de/avatare"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c1.t5.title')"
        :textArray="uakCompTexts"
        :linkText="$t('dept.c1.t5.link')"
        linkUrl="https://bc.schulamt-bw.de/,Lde/Startseite/Themen-ABC/nachteilsausgleich?LISTPAGE=cbi:///cms/9844640"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('dept.c2.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c2.t1.title')"
        :textArray="kjppLessonTexts"
        :downloadText="$t('dept.c2.t1.download')"
        downloadFileName="Allgemeine_Infos_2023.pdf"
      />
      <ContentImageTile
        embedded
        imageSource="/img/schulhaus/04.jpg"
        :caption="$t('dept.c2.img.caption')"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('dept.c2.t2.title')"
        :textArray="kjppGoalsTexts"
        :downloadText="$t('dept.c2.t2.download')"
        downloadFileName="Hans-Lebrecht-Schule_KJP.pdf"
      />
    </ContentContainer>
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentContainer from '@/views/components/ContentContainer.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ContentFrame from '@/views/components/ContentFrame.vue'

export default {
  name: 'Departments',
  components: {
    ContentContainer,
    ContentTile,
    ContentImageTile,
    ContentFrame
  },
  computed: {
    ...mapGetters(['menuData']),
    computedTopicColor () {
      return this.menuData.departments.color
    },
    computedTitle () {
      return this.menuData.departments.title
    },
    uakGoalsTexts () {
      return [
        this.$t('dept.c1.t1.p0'),
        this.$t('dept.c1.t1.p1'),
        this.$t('dept.c1.t1.p2')
      ]
    },
    uakHomeLessonTexts () {
      return [
        this.$t('dept.c1.t3.p0'),
        this.$t('dept.c1.t3.p1'),
        this.$t('dept.c1.t3.p2')
      ]
    },
    uakAvatarTexts () {
      return [
        this.$t('dept.c1.t4.p0'),
        this.$t('dept.c1.t4.p1'),
        this.$t('dept.c1.t4.p2')
      ]
    },
    uakCompTexts () {
      return [
        this.$t('dept.c1.t5.p0'),
        this.$t('dept.c1.t5.p1'),
        this.$t('dept.c1.t5.p2')
      ]
    },
    kjppLessonTexts () {
      return [
        this.$t('dept.c2.t1.p0'),
        this.$t('dept.c2.t1.p1')
      ]
    },
    kjppGoalsTexts () {
      return [
        this.$t('dept.c2.t2.p0'),
        this.$t('dept.c2.t2.p1'),
        this.$t('dept.c2.t2.p2'),
        this.$t('dept.c2.t2.p3')
      ]
    }
  }
}
</script>

<style scoped>
</style>
